import React, {useEffect, useState} from "react";
import axios from 'axios';
import MarkdownRenderer from "./MarkdownRenderer";

import introduction from "../assets/images/introduction.png";

export default function About() {
  const [intro, setIntro] = useState({});

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_STRAPI_API_URL}/introduction?populate=*`, {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_STRAPI_TOKEN}`,
      }
    }).then(res => {
      setIntro(res.data.data);
    }).catch(err => console.error(err));
  }, [])

  return (
    <section className="py-16 bg-green-50 px-4">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">
        <div className="flex-1">
          <img src={introduction} alt="Farmer" className="w-full max-w-md mx-auto" />
        </div>
        <div className="flex-1">
          <MarkdownRenderer content={intro.short_introduction}/>
          <button className="bg-yellow-400 hover:bg-yellow-500 px-6 py-3 rounded-xl font-semibold text-black">
            Giới Thiệu Về Chúng Tôi
          </button>
        </div>
      </div>
    </section>
  );
}
